import React, { useEffect, useState } from "react";
import styles from "../style/pages/concertVideoPage.module.css";
import { useParams } from "react-router-dom";
import axios from "axios";
import likeIcon from "../assets/svg/like.svg";
import likeIconNull from "../assets/svg/like null.svg";
import ModalAuth from "../components/ModalAuth";
import { Link, useHistory } from "react-router-dom";

import Modal from "../components/Modal";

const ConcertVideoPage = () => {
  const [video, setVideo] = useState({});
  const [hovered, setHovered] = useState(false);
  const [isModalActive, setIsModalActive] = useState(false);
  const [openAuthModal, setOpenAuthModal] = useState(false);
  const [isBougth, setIsBougth] = useState(false);
  const history = useHistory();
  const [favouritesVideos, setFavoritesVideos] = useState(
    JSON.parse(localStorage.getItem("favouritesVideos")) ?? []
  );
  const [userInfo, setUserInfo] = useState({});

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("token"));
    if (token) {
      setUserInfo(token);
    }
  }, []);

  const { id } = useParams();
  useEffect(() => {
    const getVideoApiById = async () => {
      try {
        const res = await axios.get(`https://rishat-tour.ru/api/videos/${id}`, {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
          },
        });
        setIsBougth(res?.data.isBougth);
        setVideo(res?.data.video);
      } catch (e) {
        console.log(e);
      }
    };
    getVideoApiById();
  }, [id, userInfo]);

  const handleOpenModal = () => {
    setIsModalActive(true);
  };

  const handleClickLike = () => {
    if (favouritesVideos.includes(video._id)) {
      setFavoritesVideos((prevState) =>
        prevState.filter((elem) => elem !== video._id)
      );
    } else {
      setFavoritesVideos([...favouritesVideos, video._id]);
    }
  };

  useEffect(() => {
    localStorage.setItem("favouritesVideos", JSON.stringify(favouritesVideos));
  }, [favouritesVideos]);

  const handleClickBuy = async () => {
    if (userInfo?.token) {
      try {
        const res = await axios.post(
          "https://rishat-tour.ru/api/payment/create-payment",
          {
            videoId: id,
          },
          {
            headers: {
              Authorization: `Bearer ${userInfo.token}`,
            },
          }
        );
        if (res.data.confirmation_url) {
          window.location.href = res.data.confirmation_url;
        }
      } catch (err) {
        console.error(err);
        alert("Ошибка при создании платежа");
      }
    } else {
      setOpenAuthModal(true);
    }
  };

  const handleCLickVideoShow = () => {
    history.push("/purchased");
  };

  return (
    <div className={styles.container}>
      <div className={styles.cartVideoWrapper}>
        <div
          onClick={handleOpenModal}
          className={styles.cartVideoLeft}
          onMouseOver={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          {!hovered ? (
            <img src={video?.posterUrl} alt="video" />
          ) : (
            <video src={video?.trailerUrl} autoPlay muted loop playsInline />
          )}
        </div>
        <div class={styles.cartVideoRight}>
          <div className={styles.cartRightInner}>
            <h5>{video?.title}</h5>
            <p>{video?.description}</p>
          </div>
          <div className={styles.cartRightInner}>
            <button onClick={handleOpenModal}>Трейлер</button>
            {isBougth ? (
              <button onClick={handleCLickVideoShow}>Смотреть</button>
            ) : (
              <button onClick={handleClickBuy}>Купить</button>
            )}
            <button onClick={handleClickLike}>
              {favouritesVideos.includes(video._id) ? (
                <img src="/like.svg" alt="" />
              ) : (
                <img src="/like null.svg" alt="" />
              )}
            </button>

            <div className={styles.buy}>{video.price}₽</div>
          </div>
        </div>
      </div>
      {isModalActive && (
        <Modal onClose={() => setIsModalActive(false)}>
          <div className={styles.cartVideoRightContainer}>
            <video
              className={styles.cartVideoRightVideo}
              src={video?.trailerUrl}
              autoPlay
              muted
              loop
              playsInline
              controls
            />
          </div>
        </Modal>
      )}
      {openAuthModal && (
        <Modal onClose={() => setOpenAuthModal(false)}>
          <ModalAuth
            openAuthModal={openAuthModal}
            setOpenAuthModal={setOpenAuthModal}
          />
        </Modal>
      )}
    </div>
  );
};

export default ConcertVideoPage;
